import { SxProps } from '@mui/material';
import { Badge } from 'framework/ui/mui-builder';
import { useDurationUtils } from './durationUtils';
import { useFieldHelper } from 'framework/ui/field';
import { Contract } from 'domain/people/employee/contracts/types';

type ContractDuractionFieldProps = {
  sxBadge?: SxProps;
  сontracts?: Contract[];
  сontractsSource?: string;
};

const ContractDuractionField = ({ sxBadge = {}, сontracts, сontractsSource }: ContractDuractionFieldProps) => {
  const { calculateTotalDuration, formatDuration } = useDurationUtils();
  const { getValue } = useFieldHelper({ value: сontracts, source: сontractsSource });

  const contractsValue = getValue() || [];

  const totalDuration = calculateTotalDuration(contractsValue);
  const formattedTotalDuration = formatDuration(totalDuration);

  return (
    <Badge
      color="default"
      sx={{
        ...sxBadge,
      }}
    >
      {formattedTotalDuration}
    </Badge>
  );
};

export default ContractDuractionField;
